<unity-outside-container [modalHeaderSubtitle]="modalHeaderSubtitle" [modalHeaderTitle]="modalHeaderTitle">
  <div class="outside-form">
    @switch (stage) {
      @case ('entry') {
        <kendo-stacklayout orientation="vertical" [gap]="15">
          <form id="resetForm" [formGroup]="resetForm" (ngSubmit)="onResetSubmit()">
            <unity-textbox-control
              displayName="Email Address"
              description="Enter the email address you signed up with."
              [showHint]="false"
              [control]="resetForm.controls.username"
              [clearButton]="true" />
          </form>
          <button kendoButton themeColor="primary" form="resetForm" type="submit" [disabled]="resetForm.invalid || formLoading">
            @if (!formLoading) {
              Email me a Password Reset Link
            }
            @if (formLoading) {
              <kendo-loader type="infinite-spinner" size="small" themeColor="info" />
            }
          </button>
          <button kendoButton themeColor="tertiary" routerLink="/login" type="button">Back to Login</button>
        </kendo-stacklayout>
      }
      @case ('complete') {
        <kendo-stacklayout orientation="vertical" [gap]="15">
          <h5>Password Reset Email Sent</h5>
          <h6>An email with instructions has been sent to:</h6>
          <div class="email-wrapper">
            <span class="email">{{ resetForm.controls.username.value }}</span>
          </div>
          <h6>
            To reset your password, please check your inbox and follow the instructions in the email.
            <br />
            If you don't see it immediately, wait a few minutes and check again.
            <br />
            Remember to check your spam or junk folder!
          </h6>
          <button kendoButton themeColor="primary" routerLink="/login" type="button">Back to Login</button>
        </kendo-stacklayout>
      }
      @case ('unconfirmed') {
        <kendo-stacklayout orientation="vertical" [gap]="15">
          <h5>The account with the following email has not been confirmed:</h5>
          <div class="email-wrapper">
            <span class="email">{{ resetForm.controls.username.value }}</span>
          </div>
          <button
            kendoButton
            themeColor="tertiary"
            type="button"
            routerLink="/resend-confirm"
            [queryParams]="{ username: resetForm.controls.username.value }">
            Request New Confirmation Email
          </button>
          <button kendoButton themeColor="primary" routerLink="/login" type="button">Back to Login</button>
        </kendo-stacklayout>
      }
    }
  </div>
</unity-outside-container>
